import { Component, inject, OnInit } from '@angular/core';
import { GungSettingsBaseViewComponent } from '../../gung-settings-base-view/gung-settings-base-view.component';
import { ConfigurationsService } from '../../../services/configurations.service';
import { GungNotificationService } from 'gung-common';
import { TranslateService } from '@ngx-translate/core';
import { catchError, first, of } from 'rxjs';

@Component({
    selector: 'lib-gung-settings-config-order-view',
    templateUrl: './gung-settings-config-order-view.component.html',
    styleUrl: './gung-settings-config-order-view.component.scss',
    standalone: false
})
export class GungSettingsConfigOrderViewComponent extends GungSettingsBaseViewComponent implements OnInit {
  protected configurationsService = inject(ConfigurationsService);
  protected gungNotificationService = inject(GungNotificationService);
  protected translateService = inject(TranslateService);

  orderConfirmConfig: any;

  ngOnInit(): void {
    this.configurationsService
      .getConfigurationsByIds(['OrderConfirmDbConfig'])
      .pipe(first())
      .subscribe(configs => {
        this.orderConfirmConfig = configs?.find(c => c.id === 'OrderConfirmDbConfig');
      });
  }

  saveOrderConfirmConfig(): void {
    // Check if orderConfirmBody contains HTML tags
    const htmlTagRegex = /<[^>]+>/;
    if (!!this.orderConfirmConfig.orderConfirmBody && htmlTagRegex.test(this.orderConfirmConfig.orderConfirmBody)) {
      this.orderConfirmConfig.useHtmlOnOrderConfirmBody = true;
    }

    this.configurationsService
      .updateConfiguration(this.orderConfirmConfig)
      .pipe(
        first(),
        catchError(() => {
          this.gungNotificationService.notify(
            this.translateService.instant('ERROR'),
            this.translateService.instant('ERROR_SAVING_CONFIGURATION'),
            'error'
          );
          return of(null);
        })
      )
      .subscribe(res => {
        if (!res) return;
        this.gungNotificationService.notify(
          this.translateService.instant('CONFIGURATION_SAVED'),
          this.translateService.instant('ORDER_CONFIRM_CONFIGURATION_SAVED_MESSAGE'),
          'success'
        );
      });
  }
}
